// Shopify cannot sort a collection by a product metafield. Load the filtered
// collection pages before applying this storefront-only sort.
(() => {
  const choices = new Map([
    ['intensity-ascending', 'ascending'],
    ['intensity-descending', 'descending'],
  ]);
  let requestId = 0;

  const parseIntensity = (value) => {
    const match = String(value ?? '').trim().match(/^(?:intensit[eé]\s*:?\s*)?(1[0-2]|[1-9])(?:\s*\/\s*(?:10|12))?$/i);
    return match ? Number(match[1]) : null;
  };

  const intensityFromHandle = (handle) => {
    const source = String(handle ?? '').toLowerCase();
    const isCapsule = source.includes('capsules-compatibles-nespresso-');
    const isDosette = source.includes('dosettes-compatibles-senseo-');
    if (!isCapsule && !isDosette) return null;
    const recipe = source.match(/(?:^|-)(lungo|doux|decafeine|equilibre|classique|espresso|ristretto|corse)(?:-|$)/)?.[1];
    const capsuleIntensities = { lungo: 5, decafeine: 6, equilibre: 7, espresso: 9, ristretto: 12 };
    const dosetteIntensities = { doux: 5, decafeine: 6, classique: 7, espresso: 8, corse: 9 };
    return (isCapsule ? capsuleIntensities : dosetteIntensities)[recipe] ?? null;
  };

  const currentDirection = () => {
    const value = new URLSearchParams(location.search).get('intensity_sort');
    return value === 'ascending' || value === 'descending' ? value : null;
  };

  const restoreSelection = () => {
    const direction = currentDirection();
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      if (select.querySelector('[value="intensity-ascending"]')) {
        select.value = direction ? `intensity-${direction}` : select.value;
      }
    });
  };

  const normalizeSearchParams = (searchParams, event) => {
    const params = new URLSearchParams(searchParams);
    const selected = event?.target?.matches?.('select[name="sort_by"]')
      ? event.target.value
      : params.getAll('sort_by').find((value) => choices.has(value));
    if (choices.has(selected)) {
      params.set('sort_by', 'manual');
      params.set('intensity_sort', choices.get(selected));
    } else if (selected) {
      params.set('sort_by', selected);
      params.delete('intensity_sort');
    } else if (currentDirection() && !params.has('intensity_sort')) {
      params.set('intensity_sort', currentDirection());
    }
    params.delete('page');
    return params.toString();
  };

  const onGridRendered = async () => {
    const id = ++requestId;
    const container = document.getElementById('ProductGridContainer');
    const grid = container?.querySelector('#product-grid.legal-conversion-grid, #product-grid.legal-collection-products__grid');
    const direction = currentDirection();
    if (!grid || !direction) {
      container?.classList.remove('legal-intensity-sorted');
      return;
    }

    const totalPages = Math.max(1, Number(grid.dataset.totalPages) || 1);
    const sectionId = grid.dataset.id;
    const params = new URLSearchParams(location.search);
    params.delete('intensity_sort');
    params.delete('page');
    params.set('sort_by', 'manual');
    params.set('section_id', sectionId);
    container.setAttribute('aria-busy', 'true');

    try {
      const pages = await Promise.all(Array.from({ length: totalPages }, async (_, index) => {
        const pageParams = new URLSearchParams(params);
        pageParams.set('page', String(index + 1));
        const response = await fetch(`${location.pathname}?${pageParams}`);
        if (!response.ok) throw new Error(`Page ${index + 1}: ${response.status}`);
        const documentForPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        const pageGrid = documentForPage.querySelector('#product-grid.legal-conversion-grid, #product-grid.legal-collection-products__grid');
        if (!pageGrid) throw new Error(`Page ${index + 1}: grille absente`);
        return [...pageGrid.children].filter((item) => item.matches('.grid-item, .legal-collection-card'));
      }));
      if (id !== requestId) return;

      const seenFamilies = new Set();
      const items = pages.flat().filter((item) => {
        const family = item.dataset.familyKey ?? item.querySelector('[data-family-key]')?.dataset.familyKey;
        if (!family) return true;
        if (seenFamilies.has(family)) return false;
        seenFamilies.add(family);
        return true;
      }).map((item, index) => ({
        item,
        index,
        intensity: parseIntensity(item.dataset.intensity || item.querySelector('[data-intensity]')?.dataset.intensity)
          ?? intensityFromHandle(item.dataset.productHandle || item.querySelector('[data-product-handle]')?.dataset.productHandle),
      }));
      items.sort((a, b) => {
        const aMissing = a.intensity === null;
        const bMissing = b.intensity === null;
        if (aMissing !== bMissing) return aMissing ? 1 : -1;
        if (aMissing) return a.index - b.index;
        return (direction === 'ascending' ? a.intensity - b.intensity : b.intensity - a.intensity) || a.index - b.index;
      });
      grid.replaceChildren(...items.map(({ item }) => item));
      container.classList.add('legal-intensity-sorted');
    } catch (error) {
      if (id === requestId) {
        console.error('Tri par intensité indisponible', error);
        container.classList.remove('legal-intensity-sorted');
        document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
          if (select.value.startsWith('intensity-')) select.value = 'manual';
        });
      }
    } finally {
      if (id === requestId) container.removeAttribute('aria-busy');
    }
  };

  window.legalIntensitySort = { normalizeSearchParams, onGridRendered, parseIntensity, restoreSelection };
  document.addEventListener('DOMContentLoaded', () => {
    restoreSelection();
    onGridRendered();
  });
})();
